@if (shouldShowMessage) {
<div class="photo-requirement-message">
    <mat-icon class="requirement-icon">check_circle_outline</mat-icon>
    <div class="requirement-text">
        @if (currentPhotoCount === 0) {
        {{ minimumPhotosRequired }} {{ minimumPhotosRequired === 1 ? 'photo is' : 'photos are' }} required to process
        this order.
        } @else {
        {{ photosStillRequired }} additional {{ photosStillRequired === 1 ? 'photo is' : 'photos are' }} required to
        process this order.
        }
    </div>
</div>
}